module.exports = __webpack_public_path__ + "img/invite_rule_info.5ee0ef17.png";